import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getTaskHistory = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/monitoring-host/tasks/details?${queries}` });

  return data?.data;
};

export default getTaskHistory;
